module.exports = __webpack_public_path__ + "img/2.63e9dfb3.jpg";